import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=37312eee&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37312eee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37312eee')) {
      api.createRecord('37312eee', component.options)
    } else {
      api.reload('37312eee', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=37312eee&scoped=true&", function () {
      api.rerender('37312eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g405pW6P39kO/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports